// Package imports:
import React from 'react';
// Component imports:
import Button from '../../ui-elements/Button/Button';

interface IProps {
    errorStatus?: number,
}

const ErrorPage: React.FC<IProps>= ({
    errorStatus
}) => {
    const { title, message } = (errorStatus === 402) ? {
        title: 'Greiðsluupplýsingar vantar',
        message: <><p>Kreditkortaupplýsingar eru ekki fullnægjandi.</p> <Button anchorProps={{href: '/Min-Kelda/Stillingar'}}>Stillingar</Button></>
    } :(errorStatus === 403) ? {
        title: '403: Aðgangur bannaður',
        message: <p>Þú hefur ekki tilskilin réttindi fyrir þessa síðu.</p>
    } : (errorStatus === 404) ? {
        title: '404: Síða finnst ekki',
        message: <p>Mögulega er sambandsleysi við vefþjón eða síðan sem þú ert að leita að er ekki lengur til.</p>
    } : (errorStatus === 410) ? {
        title: '410: Síðu eytt',
        message: <p>Síðan sem þú ert að leita að er ekki lengur til.</p>
    } : (errorStatus === 500) ? {
        title: '500: Innri netþjónsvilla',
        message: <p>Svo virðist sem netþjónninn hafi lent í aðstæðum sem hann veit ekki hvernig á að höndla.</p>
    } : {
        title: 'Úps... þetta er vandræðalegt',
        message: <p>Mögulega er sambandsleysi við vefþjón eða síðan sem þú ert að leita að er ekki lengur til.</p>
    }

    return (
        <div className='KCL_errorPage'>
            <div className="errorPage-leftBox">
                <h2 className="errorPage-title">{title}</h2>
                {errorStatus === 402 || errorStatus === 403 || errorStatus === 410
                    ? <div className="errorPage-message">
                        {message}
                    </div>
                    : <>
                        <div className="errorPage-message">
                            {message}
                            <p>Keldufólkið er líklega á fullu að vinna að lausn. Á meðan getur þú litið til dæmis á Kaupsamninga:</p>
                        </div>
                        <Button anchorProps={{href: "/Fasteignir/Kaupsamningar"}}>
                            Skoða kaupsamninga
                        </Button>
                    </>
                }
            </div>
            <div className="errorPage-rightBox">
                <h1 className="errorPage-errorStatusCode1">{errorStatus !== undefined && errorStatus !== 402 ? errorStatus : '???'}</h1>
                <h1 className="errorPage-errorStatusCode2">{errorStatus !== undefined && errorStatus !== 402 ? errorStatus : '???'}</h1>
                <h1 className="errorPage-errorStatusCode3">{errorStatus !== undefined && errorStatus !== 402 ? errorStatus : '???'}</h1> 
            </div>
            
        </div>
    );
}

export default ErrorPage;